<template>
  <div class="position-relative">
    <!-- shape Hero -->
    <section class="section-shaped my-0">
      <div class="shape shape-style-1 shape-default shape-skew"></div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-2 text-white">Contato</h1>
              <span class="text-white"
                >Entre em contato por e-mail através do formulário!</span
              >
              <br />
              <br />
              <br />
              <!-- <p class="lead text-white">
                  The design system comes with four pre-built pages to help you
                  get started faster. You can change the text and images and
                  you're good to go.
                </p> -->
              <!-- <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                    class="mb-3 mb-sm-0"
                    type="info"
                    icon="fa fa-code"
                  >
                    Components
                  </base-button>
                  <base-button
                    tag="a"
                    href="https://www.creative-tim.com/product/argon-design-system"
                    class="mb-3 mb-sm-0"
                    type="white"
                    icon="ni ni-cloud-download-95"
                  >
                    Download HTML
                  </base-button>
                </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- email -->
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Formulário</h4>
              <p class="mt-0">Seu contato é muito importante!</p>
              <base-input
                class="mt-5"
                alternative
                placeholder="Qual seu nome?"
                v-model="email.name"
                addon-left-icon="fa fa-user"
              >
              </base-input>
              <base-input
                alternative
                placeholder="Qual o assunto?"
                v-model="email.subject"
                addon-left-icon="ni ni-user-run"
              >
              </base-input>
              <base-input
                alternative
                placeholder="Qual seu endereço de e-mail?"
                v-model="email.from"
                addon-left-icon="ni ni-email-83"
              >
              </base-input>
              <base-input class="mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  rows="4"
                  cols="80"
                  v-model="email.message"
                  placeholder="Insira uma mensagem"
                ></textarea>
              </base-input>
              <base-button
                type="default"
                round
                block
                size="lg"
                @click="sendEmail"
              >
                <span
                  v-if="loadingMail"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="false"
                >Carregando...</span>
                <span v-else>Enviar</span>
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section>

    <!-- Mapa -->
    <section class="section section-lg pt-lg-0 bg-secondary">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              <span class="text-success my-5">De onde eu sou?</span>
            </h2>
          </div>
          <div class="col-lg-12">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d236815.87428823469!2d-51.49362480824999!3d-21.963441575436974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9493f5b311570c5b%3A0xda475801fc46afb9!2sPres.%20Prudente%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1617890824403!5m2!1spt-BR!2sbr"
              width="100%"
              height="450"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  showError,
  showSuccess,
  EMAIL_SERVICE,
  EMAIL_TEMPLATE,
  EMAIL_USER_ID,
} from "@/global";
import emailjs from "emailjs-com";

export default {
  name: "contact",
  data: () => ({
    email: {},
    loadingMail: false,
  }),
  methods: {
    sendEmail() {
      if (!this.email.from || !this.email.message || !this.email.subject)
        return;

      this.loadingMail = true;
      emailjs
        .send(
          EMAIL_SERVICE,
          EMAIL_TEMPLATE,
          {
            name: this.email.name || "Desconhecido",
            subject: this.email.subject,
            email: this.email.from,
            message: this.email.message,
          },
          EMAIL_USER_ID
        )
        .then(() => {
          showSuccess("Obrigado por entrar em contato, retornarei em breve!");
          this.email = {};
        })
        .catch(() =>
          showError(
            "Nõ foi possível enviar o email, tente novamente mais tarde"
          )
        )
        .finally(() => (this.loadingMail = false));
    },
  },
};
</script>

<style>
</style>